// TODO: move to a common module?
export enum CompanyRole {
  HEAD_ADMIN = "headAdmin",
  ADMIN = "admin",
  USER = "user",
}
